import { ModuleKeyValueTable } from './TranslationProvider';
import { ResponseBase } from '../Messaging/ResponseBase';

/**
 * Get the respond to a TranslationMessage.
 */
export class TranslationResponse extends ResponseBase {
  /**
   * The active language.
   */
  activeLanguage!: string;

  /**
   * The active language script.
   */
  activeLanguageScript!: string;

  /**
   * The active language region.
   */
  activeLanguageRegion!: string;

  /**
   * The translation for the current languages.
   */
  translations!: ModuleKeyValueTable;
}